import { useParams } from 'react-router-dom';
import { cn } from '@/lib/cn';
import { ChatSidebar } from '@/features/client/web/chat/chat-sidebar';
import { ChatThread } from '@/features/client/web/chat/chat-thread';

// Thin wrapper that reuses the client chat UI with associate-scoped sidebar.
// The chat thread (messages + composer) is role-neutral — the server scopes
// transitions via role checks, so the UI is identical.
export function AssociateChatPage() {
  const { threadId } = useParams<{ threadId: string }>();
  return (
    <div
      className={cn(
        'flex w-full bg-gray-50 h-full min-h-0 flex-1 overflow-hidden',
        threadId ? 'fixed inset-0 z-30 h-[100dvh] md:static md:z-auto md:h-full' : 'h-full',
      )}
    >
      <div
        className={cn(
          'flex w-full flex-col border-r border-gray-200 md:w-80 md:max-w-sm md:shrink-0 h-full min-h-0 overflow-hidden',
          threadId ? 'hidden md:flex' : 'flex',
        )}
      >
        <ChatSidebar selectedId={threadId} basePath="/associate/chat" scope="associate" />
      </div>

      {threadId ? (
        <ChatThread transactionId={threadId} />
      ) : (
        <div className="hidden flex-1 items-center justify-center bg-gray-50 md:flex">
          <div className="max-w-md text-center">
            <h2 className="text-base font-semibold text-gray-900">Select a conversation</h2>
            <p className="mt-1 text-sm text-gray-600">
              Pick an assigned transaction on the left to see the chat.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
